import { primaryOnColorStyles, primaryStyles, subtleOnColorStyles, subtleStyles } from '../constants/colorStyles'
import { BadgeColor, BadgeMode, ColorStyles } from '../types/colorStyles'

export const getColorStyles = (color: BadgeColor, mode: BadgeMode, onColor: boolean): ColorStyles => {
  if (mode === 'primary') {
    return onColor ? primaryOnColorStyles[color] : primaryStyles[color]
  }
  return onColor ? subtleOnColorStyles[color] : subtleStyles[color]
}
